import { Axis } from 'highcharts/highstock';
import { getDefaultScrollBarOptions } from 'components/organisms/dashboard/chart-options/utils';
import { setChartExtremes } from 'components/organisms/dashboard/components/chart-formatting-utils';

export const getChartOptions = (
  xAxisLabels,
  seriesData,
  xAxisTitle,
  yAxisTitle,
) => {
  return {
    chart: {
      type: 'spline',
      scrollablePlotArea: {
        maxWidth: 500,
        scrollPositionX: 1,
      },
      style: {
        fontFamily: 'var(--font-family)',
      },
      zoomType: 'xy',
      panKey: 'shift',
    },
    title: {
      text: '',
    },
    series: seriesData,
    yAxis: {
      title: {
        text: yAxisTitle,
      },
      lineWidth: 1,
      gridLineWidth: 0,
      lineColor: 'var(--gray-20)',
    },
    xAxis: {
      lineWidth: 1,
      gridLineWidth: 0,
      lineColor: 'var(--gray-20)',
      type: 'category',
      categories: xAxisLabels,
      max: xAxisLabels.length > 12 ? 12 : xAxisLabels.length - 1,
      title: { text: xAxisTitle },
      accessibility: {
        rangeDescription: xAxisTitle,
      },
      labels: {
        style: {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: 80,
        },
      },
      events: {
        afterSetExtremes() {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const xAxis = this;

          setChartExtremes(xAxis as any as Axis);
        },
      },
      scrollbar: {
        enabled: xAxisLabels.length > 12,
        ...getDefaultScrollBarOptions(),
      },
    },
    plotOptions: {
      series: {
        cropThreshold: 2000,
        connectNulls: true,
        dataLabels: {
          enabled: true,
        },
      },
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'left',
      verticalAlign: 'bottom',
      maxHeight: 70,
      itemStyle: {
        fontWeight: 'var(--font-weight-normal)',
      },
    },
  };
};
